<template>
    <div>
        <br>
        <nav v-on:submit.prevent="searchMaterial" class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input class="form-control mr-sm-2"
                           v-model="search.material"
                           type="search"
                           placeholder="รหัส"
                           aria-label="Search"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchMaterial"
                            type="button">
                            <icon name="search"></icon>
                            ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div>
            <div class="mr-auto">
                <button @click="clearInspect(1)"
                        class="btn btn-danger mr-auto my-2 my-sm-0"
                        type="button">
                    เริ่มตรวจสอบใหม่
                </button>&nbsp
            </div>
        </div>
        <table class="table table-bordered text-center">
            <thead>
            <tr>
                <th scope="col">รหัสวัตถุดิบ</th>
                <th scope="col">กะ</th>
                <th scope="col">ระบุจำนวนคงเหลือในโกดัง</th>
                <th scope="col">การตรวจสอบ</th>
                <th scope="col">เปลี่ยนกะ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(data,index) in material_inspect">
                <td>{{data.materials.code}}</td>
                <td>กลางวัน</td>
                <td>
                    <input style="text-align: center"
                           class="form-control"
                           v-on:keyup.enter="saveIntoPreOrder(data.id,data)"
                           v-model="data.quantity"
                           :disabled="data.status_id==1"/>
                </td>
                <td>
                    <template v-if="data.status_id==1">
                        <button class="btn btn-primary">เสร็จสิ้น</button>
                    </template>
                    <template v-else>
                        <button @click="saveIntoPreOrder(data.id,data)"
                                class="btn btn-success">
                            ตรวจสอบแล้ว
                        </button>
                    </template>
                </td>
                <td>
                    <b-form-select v-model="data.shift_id" :options="optionShift" class="mb-3" />
                </td>
            </tr>
            </tbody>
        </table>
        <br>
        <!--<pre class="alert alert-primary">{{ material_inspect }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment";
    export default {
        name: "day-shift-list",
        components:{Multiselect},
        data(){
          return {
              currentDate : "",
              search:{
                  material : ""
              },
              material_all : [],
          }
        },
        created(){
            this.getCurrentDate();
            this.$store.dispatch('MaterialInspect/get');
            this.$store.dispatch('Common/setShiftWork');
            this.getMaterialAll();
        },
        computed:{
            ...mapState({
                material_inspect : state=>{
                    return [
                        ...state.MaterialInspect.table
                            .filter(data => data.shift_id == 1)
                    ]
                },
                user: state => {
                    return state.Auth.user;
                },
                optionShift:state=>{
                    return [
                        ...state.Common.shift_work.map(shift => ({
                            value: shift.id,
                            text: shift.name
                        }))
                    ];
                }
            })
        },
        methods:{
            saveIntoPreOrder(id,info){
                let data = {
                    //save Material Inspection
                    material_id : id,
                    shift_id : info.shift_id,
                    quantity : info.quantity,
                    status_id : 1,
                    user_id : this.user.id,
                    material_code : info.materials.code,

                    //save Checked list
                    material_remain  : info.quantity,
                    po_quantity : "",
                    checked_date : this.currentDate
                };
                this.$store.dispatch('MaterialInspect/update',{
                    id : id,
                    data : data
                })
                    .then(()=>{
                    if(data.quantity){
                        this.$store.dispatch('CheckList/create',data).then(()=>{
                            this.$store.dispatch('MaterialInspect/get')
                        })
                    }
                })
                .then(()=>{
                    this.$store.dispatch('MaterialInspect/get')
                })
            },
            clearInspect(shift){
              this.$store.dispatch('MaterialInspect/clear',shift).then(()=>{
                  this.$store.dispatch('MaterialInspect/get')
              });
            },
            getMaterialAll(){
                this.$store.dispatch('Material/getAll').then(res=>{
                    this.material_all = res;
                });
            },
            getCurrentDate(){
                const currentDate = moment().format("YYYY-MM-DD");
                this.currentDate = currentDate;
            },
            searchMaterial(){
                this.$store.dispatch('MaterialInspect/search',this.search.material)
            }
        }

    }
</script>

<style lang="scss" scoped>
    @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
        /* Force table to not be like tables anymore */
        table,
        thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        /* Hide table headers (but not display: none;, for accessibility) */
        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr {
            border: 1px solid #ccc;
        }

        td {
            /* Behave  like a "row" */
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%;
        }

        td:before {
            /* Now like a table header */
            position: absolute;
            /* Top/left values mimic padding */
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
        }
        td:nth-of-type(1):before {
            content: "รหัสวัตถุดิบ";
        }
        td:nth-of-type(2):before {
            content: "กะ";
        }
        td:nth-of-type(3):before {
            content: "คงเหลือในโกดัง";
        }
        td:nth-of-type(4):before {
            content: "การตรวจสอบ";
        }
        td:nth-of-type(5):before {
            content: "เปลี่ยนกะ";
        }
    }
</style>
